import { AppRouter } from "./routers/AppRouter";
import ReactGA from 'react-ga4';
import './App.css'


function App() {
  let pageTitle = "Machine Football";
  let environment = process.env.REACT_APP_MODE??"";
  //console.log("environment +> ", environment)
  switch(environment){
    case "development":
      pageTitle = pageTitle + " DEV";
      break;
    case "qa":
      pageTitle = pageTitle + " QA";
      break;
     case "staging":
      pageTitle = pageTitle + " Staging";
      break;
     default:
      break;
  }
  document.title = pageTitle;
  if(environment === "production"){
    ReactGA.initialize('G-VRXMXEW0WW');
  }
  return (
    <AppRouter />
  );
}

export default App;
